<template>
  <div>
    <u-loader v-if="isLoading" />
    <div v-else>
      <v-expansion-panel
        v-model="panel_object"
        expand
      >
        <v-expansion-panel-content
          v-for="(objectValue, i) in objectValues"
          :key="i"
          :class="getValidHeaderClass(objectValue.valid_value)"
        >
          <template v-slot:header>
            <div v-if="translationType == 'klauseln'">
              <i
                v-if="objectValue.valid_value"
                class="fas fa-check-circle pr-2 checkCircle"
              />
              <i
                v-else
                class="fas fa-minus-circle pr-2 minusCircle"
              />
              {{ getKlauselHeader(objectValue) }}
            </div>
            <div v-else-if="translationType == 'alternativTextsToTranslate'">
              <i
                v-if="objectValue.valid_value"
                class="fas fa-check-circle pr-2 checkCircle"
              />
              <i
                v-else
                class="fas fa-minus-circle pr-2 minusCircle"
              />
              Alternativtext:
              {{ i + 1 }}
            </div>
            <div v-else-if="translationType == 'textblocksToTranslate'">
              <i
                v-if="objectValue.valid_value"
                class="fas fa-check-circle pr-2 checkCircle"
              />
              <i
                v-else
                class="fas fa-minus-circle pr-2 minusCircle"
              />
              {{ getTextblockHeader(objectValue) }}
            </div>
            <div v-else>
              <i
                v-if="objectValue.valid_value"
                class="fas fa-check-circle pr-2 checkCircle"
              />
              <i
                v-else
                class="fas fa-minus-circle pr-2 minusCircle"
              />
              {{ objectValue.code }}
            </div>
          </template>
          <!-- Wenn es Alternativtexte sind zum Übersetzen -->
          <div v-if="translationType == 'alternativTextsToTranslate'">
            <translation-tiny-mce-editor
              :can-user-edit="canUserEdit"
              :contents="objectValue.contents"
              @updateValidation="updateValidation()"
            />
          </div>
          <!-- Wenn es Tetxblöcke sind zum Übersetzen -->
          <div
            v-else-if="
              translationType == 'textblocksToTranslate' &&
                objectValue.type &&
                objectValue.type != 1
            "
          >
            <translation-tiny-mce-editor
              :can-user-edit="canUserEdit"
              :contents="objectValue.contents"
              @updateValidation="updateValidation()"
            />
          </div>
          <div v-else-if="'contents' in objectValue">
            <!-- contents vorhanden -->
            <v-card
              class="pb-2 mb-4 ml-4 pl-3 pr-3 mt-3 objectCard"
              max-width="800"
            >
              <div
                v-for="(content, j) in objectValue.contents"
                :key="j"
                class="pt-2 mt-2"
              >
                <!-- Wenn es Eingabekriterien sind zum Übersetzen -->
                <div v-if="translationType == 'criteriaListEntriesToTranslate'">
                  <translation-text-field
                    :can-user-edit="canUserEdit"
                    :language="content.language"
                    :value="content.text"
                    @updateValidation="updateValidation()"
                    @update:value="content.text = $event"
                  />
                </div>
                <!-- Wenn es Tetxblöcke sind zum Übersetzen -->
                <div
                  v-else-if="translationType == 'textblocksToTranslate'"
                  class="mt-3"
                >
                  <h5 v-if="content.language == 'de-CH'">
                    Deutsch
                  </h5>
                  <h5 v-if="content.language == 'fr-CH'">
                    Französisch
                  </h5>
                  <h5 v-if="content.language == 'it-CH'">
                    Italienisch
                  </h5>
                  <h6>Text hinter Titel</h6>
                  <translation-text-field
                    :can-user-edit="canUserEdit"
                    :language="content.language"
                    :value="content.text"
                    @updateValidation="updateValidation()"
                    @update:value="content.text = $event"
                  />
                  <h6>Text in 2. Spalte</h6>
                  <translation-text-field
                    :can-user-edit="canUserEdit"
                    :language="content.language"
                    :value="content.description"
                    @updateValidation="updateValidation()"
                    @update:value="content.description = $event"
                  />
                  <hr>
                </div>

                <div
                  v-else-if="translationType == 'links'"
                  class="mt-3"
                >
                  <links-block
                    :can-user-edit="canUserEdit"
                    :content="content"
                    @updateValidation="updateValidation()"
                  />
                </div>

                <!-- Normalfall wenn content.value vorhanden ist -->
                <div v-else-if="'value' in content">
                  <translation-text-field
                    :can-user-edit="canUserEdit"
                    :language="content.language"
                    :value="content.value"
                    @updateValidation="updateValidation()"
                    @update:value="content.value = $event"
                  />
                </div>
                <v-card v-else>
                  <v-card-text class="grey lighten-3">
                    Keine Einträge vorhanden.
                  </v-card-text>
                </v-card>
              </div>
            </v-card>
          </div>
          <div v-else>
            <div v-if="translationType == 'klauseln'">
              <div
                v-if="
                  objectValue.klauselContents &&
                    objectValue.klauselContents.length
                "
              >
                <!-- klauselcontents -->
                <translation-tiny-mce-editor
                  :can-user-edit="canUserEdit"
                  :contents="objectValue.klauselContents"
                  @updateValidation="updateValidationKlausel()"
                />
              </div>
              <v-card v-else>
                <v-card-text class="grey lighten-3">
                  Keine Einträge für "{{ getKlauselHeader(objectValue) }}"
                  vorhanden.
                </v-card-text>
              </v-card>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
  </div>
</template>

<script>
import TranslationTextField from "./EditionTranslations_TextField";
import TranslationTinyMceEditor from "./EditionTranslations_TinyMceEditor.vue";
import LinksBlock from "./EditionTranslations_SubPanel_Links";
// import { LoadAllCriterionConfigurations } from "@/services/criterion.management.service.js";
export default {
  components: {
    TranslationTextField,
    TranslationTinyMceEditor,
    LinksBlock,
  },
  props: {
    canUserEdit: {
      type: Boolean,
      default: false,
    },
    objectValues: {
      type: Array,
      default: null,
    },
    translationType: {
      type: String,
      default: "",
    },
    allCriterionConfiguration: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      errorObject: null,
      panel_object: [],
    };
  },

  methods: {
    updateValidation() {
      this.$emit("updateValidation");
    },
    updateValidationKlausel() {
      this.$emit("updateValidationKlausel");
    },
    getKlauselHeader(value) {
      return this.allCriterionConfiguration.find(
        (criterionConfiguration) =>
          value.klauselTypId == criterionConfiguration.klauselTypeId,
      ).value;
    },
    getTextblockHeader(value) {
      if (value.type == 1) {
        return "Resultvariable Texte: " + value.code;
      } else if (value.type == 2) {
        return "Fussnote: " + value.code;
      } else if (value.type == 3) {
        return "Zusätzlicher Text: " + value.code;
      }
    },
    getValidHeaderClass(value) {
      return { secoundPanel: value, errorSecoundPanel: !value };
    },
  },
};
</script>

<style>
.secoundPanel .v-expansion-panel__header {
  background-color: white !important;
  background: white !important;
  color: black !important;
  border-bottom: 1px solid #808080 !important;
  border-left: 6px solid rgb(76, 175, 80);
  font-weight: normal !important;

  transition: background 0.4s linear;
}

.objectCard {
  border: 1px solid rgba(204, 204, 204, 0.5) !important;
  border-radius: 4px !important;
  background: rgba(204, 204, 204, 0.1) !important;
}

.errorSecoundPanel .v-expansion-panel__header {
  animation-duration: 4s !important;
  background: rgba(198, 40, 40, 0.2) !important;
  color: black !important;
  border-bottom: 1px solid #808080 !important;
  border-left: 6px solid rgb(198, 40, 40);

  transition: background 0.4s linear;
}

.checkCircle {
  /* color: rgb(23, 117, 28); */
  color: #018749;
}

.minusCircle {
  color: rgb(198, 40, 40);
}
</style>
